import { EventNameTypes, makeSegmentTrackCall } from '../../../javascript/analytics';
import { sendBucketEvent } from '../../../javascript/heap';

export const trackSignUpActivity = ({ planType, cart, quantity, locationUuid, subtotalData }, step, eventName) => {
  const trackProperties = {
    plan_type: planType,
    inventory_price: subtotalData?.analytics_data.inventory_price,
    currency: subtotalData?.currency,
    discount_percent: subtotalData?.monthly_fees?.discount,
    quantity,
    reservable_uuid: cart?.reservables_uuids[0],
    building_uuid: locationUuid,
    page_type: document.documentElement.className,
    ...(eventName && { label: eventName }),
    ...((step || step === 0) && { step })
  };
  // As per slack discussion https://wework.slack.com/archives/G014C5H8B0F/p1651558582403939, these two events are for the same event but different event names. The first one will be removed when the tracking project is completed with optimized labels and models.
  makeSegmentTrackCall(EventNameTypes.signupActivity, trackProperties);
  makeSegmentTrackCall(eventName, trackProperties);
};

export const trackInteraction = (label) => makeSegmentTrackCall(EventNameTypes.interaction, { label });

export const track3dsCheckout = (
  step,
  status = null,
  error = null,
  is3dsChallenge = null,
  { planType, selectedBuilding, selectedLocation }
) => {
  const trackProperties = {
    buildingName: selectedBuilding.name,
    marketName: selectedLocation.name,
    buildingId: selectedBuilding.id,
    marketId: selectedLocation.id,
    is3dsChallenge,
    planType,
    status,
    error,
    step
  };

  makeSegmentTrackCall(EventNameTypes.checkout3ds, trackProperties);
};

export const trackBucket = (label) => sendBucketEvent(label);

export const trackUserIdentity = () => {
  global.analytics.identify(
    window.analyticsGlobals.userId,
    {},
    {
      integrations: {
        Heap: true
      }
    }
  );
};
